module.exports = __webpack_public_path__ + "img/121.3.4d77b990.png";